import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { KwikUILabelValuePairComponent } from "./label-value-pair.component";
import { LabelValuePairLabelComponent } from "./label-value-pair-label/label-value-pair-label.component";
import { LabelValuePairValueComponent } from "./label-value-pair-value/label-value-pair-value.component";
import { LabelValuePairSeparatorComponent } from "./label-value-pair-separator/label-value-pair-separator.component";
import { LabelValuePairPlaceholderComponent } from "./label-value-pair-placeholder/label-value-pair-placeholder.component";
import { KwikUISafeHtmlPipeModule } from "../../../pipes/safe-html/safe-html.module";

@NgModule({
  declarations: [
    KwikUILabelValuePairComponent,
    LabelValuePairLabelComponent,
    LabelValuePairValueComponent,
    LabelValuePairSeparatorComponent,
    LabelValuePairPlaceholderComponent
  ],
  imports: [CommonModule, KwikUISafeHtmlPipeModule],
  exports: [KwikUILabelValuePairComponent]
})
export class KwikUILabelValuePairModule {}
